module.exports = __webpack_public_path__ + "img/29ne.86ca2495.svg";